export const RECIPIENTS_RESET = 'RECIPIENTS_RESET';

export const RECIPIENTS_GET_REQUEST = 'RECIPIENTS_GET_REQUEST';
export const RECIPIENTS_GET_SUCCESS = 'RECIPIENTS_GET_SUCCESS';
export const RECIPIENTS_GET_FAILURE = 'RECIPIENTS_GET_FAILURE';
